module.exports = __webpack_public_path__ + "img/TIDES-logo-color.107b7c07.svg";